// src/pages/user/Hotels/TasksPage.jsx
import React from 'react';

const TasksPage = () => {
  return (
    <div>
      <h1>Tasks</h1>
      <p>Manage housekeeping tasks here.</p>
    </div>
  );
};

export default TasksPage;
